import * as React from 'react';
import { connect } from 'react-redux';
import './App.css';
import { Analysis } from './Analysis/Analysis';
import { ChunkListMO } from '../models/ChunkListMO';
import { types } from '../constants/types';
import { ChunkDetailsMO } from '../models/ChunkDetailsMO';
import ChunkDetails from './ChunkDetails/ChunkDetails';
import { ChunkNodeMO } from '../models/ChunkNodeMO';
import Graph from './Graph/Graph';
import { WordTypeScoreMO } from '../models/WordTypeScoreMO';
import WdCommandBar from './WdCommandBar/WdCommandBar';

import Diagnosis from './Diagnosis/Diagnosis';
import SettingsPane from './SettingsPane/SettingsPane';
import { ExclusionsMO } from '../models/ExclusionsMO';
import { ThemeMO } from '../models/ThemeMO';
import { ConfigManager } from '../Manager/ConfigManager';
import { LocalStorageManager } from '../Manager/LocalStorageManager';
import { GraphCheckListMO } from '../models/GraphCheckListMO';
import { ChunkDataMO } from '../models/ChunkDataMO';
import TextInput from '../../TextInput';

export interface AppProps {
	// redux
	chunkDetailsMO: ChunkDetailsMO;
	setChunkDetailsMO: Function;

	chunkListMO: ChunkListMO;
	setChunkListMO: Function;

	wordTypeScoreMO: WordTypeScoreMO;
	setWordTypeScoreMO: Function;

	exclusionsMO: ExclusionsMO;
	setExclusionsMO: Function;

	themeMO: ThemeMO;
	setThemeMO: Function;

	setGraphCheckListMO: Function;
	isShowInfoPane: boolean;
	isShowSettingsPane: boolean;
	webTextInput: {
		text: string;
		refreshToggle: boolean;
		forceLoadToggle: false;
	};
	downloadAddins: {
		showDownloadButton: boolean;
	};
}

export interface AppState {
	isLoad: boolean;
	statusInfo: string;
}

class App extends React.Component<AppProps, AppState> {
	private analysis: Analysis;
	constructor(props: any, context: any) {
		super(props, context);

		this.analysis = new Analysis();

		let _graphCheckListMO = new GraphCheckListMO();
		this.props.setGraphCheckListMO(_graphCheckListMO);

		let _exclusionsMO =
			LocalStorageManager.getExclusionsMOFromLocalStorage() ||
			ConfigManager.getDefaultExclusions();
		this.props.setExclusionsMO(_exclusionsMO);

		let _themeMO =
			LocalStorageManager.getThemeMOFromLocalStorage() ||
			ConfigManager.getDefaultTheme();
		this.props.setThemeMO(_themeMO);
	}

	componentDidMount() {
		this.getWordDocument(this.props.webTextInput.text);
	}

	componentWillReceiveProps(nextProps: AppProps) {
		if (this.props.webTextInput && nextProps.webTextInput) {
			if (
				this.props.webTextInput.forceLoadToggle !==
				nextProps.webTextInput.forceLoadToggle
			) {
				this.props.setGraphCheckListMO(new GraphCheckListMO());
				this.getWordDocument(nextProps.webTextInput.text);
			} else if (
				this.props.webTextInput.refreshToggle !==
				nextProps.webTextInput.refreshToggle
			) {
				this.getWordDocument(nextProps.webTextInput.text);
			}
		}
	}

	updateChunkDetails = (chunkListMO: ChunkListMO) => {
		const { chunkDetailsMO, setChunkDetailsMO } = this.props;
		if (chunkListMO.length === 1) {
			chunkDetailsMO.index = 0;
			chunkDetailsMO.isShow = true;
		}
		if (
			chunkListMO.isFewWordCount ||
			chunkListMO.length <= chunkDetailsMO.index
		) {
			chunkDetailsMO.isShow = false;
			chunkDetailsMO.data = new ChunkDataMO();
			setChunkDetailsMO(chunkDetailsMO);
		} else if (chunkDetailsMO.isShow === true) {
			let chunk: ChunkNodeMO | null = chunkListMO.getChunkAtIndex(
				chunkDetailsMO.index,
			);
			chunkDetailsMO.data = chunk !== null ? chunk.data : new ChunkDataMO();
			setChunkDetailsMO(chunkDetailsMO);
		}
		return chunkDetailsMO;
	};

	getWordDocument = async (text: string) => {
		const { setChunkListMO, setWordTypeScoreMO, exclusionsMO } = this.props;
		text = text.replace(/\r\n|\r/g, '\n');
		let paragraphs = text.split('\n');
		let nodePerProcess = ConfigManager.getNodePerProcess();

		let newChunkListMO: ChunkListMO = new ChunkListMO();
		let temp = null;
		do {
			temp = this.analysis.countEligibleWords(
				newChunkListMO,
				paragraphs,
				exclusionsMO,
				nodePerProcess,
			);
			setChunkListMO(temp);
			this.setState({
				...this.state,
				statusInfo: `(${temp.nodeProcessed}/${temp.length})`,
			});
		} while (newChunkListMO.lastLoadedParagraphIndex !== paragraphs.length);
		let tempChucked = this.analysis.splitIntoChunks(temp);
		let chunkDetailsMO = this.updateChunkDetails(tempChucked);
		setChunkListMO(tempChucked);
		setWordTypeScoreMO(
			chunkDetailsMO.isShow && chunkDetailsMO.data != null
				? chunkDetailsMO.data.wordTypeScore
				: tempChucked.wordTypeScore,
		);
	};

	setLoading = () => {
		this.setState({ ...this.state, isLoad: true }, () => {
			//
		});
	};

	setNextWordTypeScoreMO = (chunkDetailsMO: ChunkDetailsMO) => {
		if (chunkDetailsMO.isShow) {
			const { setWordTypeScoreMO } = this.props;
			setWordTypeScoreMO(chunkDetailsMO.data.wordTypeScore);
		}
	};

	moveChunkHandler(index: number, chunkNodeMO: ChunkNodeMO) {
		const { setChunkDetailsMO, chunkDetailsMO } = this.props;
		if (chunkDetailsMO.index === index) return;
		chunkDetailsMO.index = index;

		// making blank data to force scroll up to top to show chunk details at the beginning
		if (chunkDetailsMO.isShow) {
			chunkDetailsMO.data = new ChunkDataMO();
			setChunkDetailsMO(chunkDetailsMO);
			setTimeout(() => {
				chunkDetailsMO.data = chunkNodeMO.data;
				setChunkDetailsMO(chunkDetailsMO);
				this.setNextWordTypeScoreMO(chunkDetailsMO);
			}, 1);
		} else {
			chunkDetailsMO.data = chunkNodeMO.data;
			setChunkDetailsMO(chunkDetailsMO);
			this.setNextWordTypeScoreMO(chunkDetailsMO);
		}
	}

	renderDetails() {
		return (
			<div>
				<ChunkDetails></ChunkDetails>
			</div>
		);
	}

	renderAppLayout() {
		const {
			downloadAddins: { showDownloadButton },
		} = this.props;
		return (
			<div className="page-container no-print">
				<div className="page-left">
					<TextInput />
				</div>
				<div className="right-app-container">
					<h1 className="test-header">
						{showDownloadButton ? 'Your Result' : <span>&nbsp;</span>}
					</h1>
					<div className="right-app">
						<div className="app-container">
							<SettingsPane refreshAction={() => {}}></SettingsPane>
							<div className="app-header">
								<WdCommandBar></WdCommandBar>
								<Graph></Graph>
								<Diagnosis></Diagnosis>
							</div>
							<div className="app-content">
								<ChunkDetails></ChunkDetails>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		return this.renderAppLayout();
	}
}

const mapDispatchToProps = (dispatch: any) => ({
	setChunkDetailsMO: (chunkDetailsMO: any) => {
		dispatch({
			type: types.SET_CHUNK_DETAILS,
			chunkDetailsMO: chunkDetailsMO,
		});
	},
	setChunkListMO: (chunkListMO: any) => {
		dispatch({
			type: types.SET_CHUNK_LIST,
			chunkListMO: chunkListMO,
		});
	},
	setWordTypeScoreMO: (wordTypeScoreMO: any) => {
		dispatch({
			type: types.SET_SCORE,
			wordTypeScoreMO: wordTypeScoreMO,
		});
	},
	setExclusionsMO: (exclusionsMO: any) => {
		dispatch({
			type: types.SET_EXCLUSIONS,
			exclusionsMO: exclusionsMO,
		});
	},
	setThemeMO: (themeMO: any) => {
		dispatch({
			type: types.SET_THEME,
			themeMO: themeMO,
		});
	},
	setGraphCheckListMO: (graphCheckListMO: any) => {
		dispatch({
			type: types.SET_GRAPH_CHECK_LIST,
			graphCheckListMO: graphCheckListMO,
		});
	},
});

const mapStateToProps = ({
	chunkDetailsMO,
	chunkListMO,
	wordTypeScoreMO,
	exclusionsMO,
	themeMO,
	isShowInfoPane,
	isShowSettingsPane,
	webTextInput,
	downloadAddins,
}: any) => ({
	chunkDetailsMO,
	chunkListMO,
	wordTypeScoreMO,
	exclusionsMO,
	themeMO,
	isShowInfoPane,
	isShowSettingsPane,
	webTextInput,
	downloadAddins,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
